/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { StorageModule } from '@vlinder-web/storage-module-react';

import { GraphqlServerModule } from '@vlinder-web/graphql-server-module-react';
import { INVITE_ORG } from '../../api/graphql';
import moment from 'moment-timezone';
import { vappContainer } from '@/application';
import { AppNavigatorService } from '@/AppNavigator';
import { Graphql } from '@/common/graphql';
import { apiConfig } from '@/config/apiConfig';

const getStorageSrv = StorageModule?.getInstance();

// const getWhoamiSrv = () => {
//   const app = VApplication.getInstance();
//   return app.getSync("services.AppNavigatorService") as AppNavigatorService;
// };

const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export interface InviteUserProps {
  email: string;
  firstName: string;
  lastName: string;
  invite: boolean;
  userRoles: boolean;
  loginRestAPI: string;
  headers: any;
  termsOfUse: any;
  orgName: string;
}
export interface IInviteUserMethods extends IPluginMethodMap {
  inviteUser(args: InviteUserProps): Promise<any>;
}

export class InviteUserService implements IAgentPlugin {
  readonly methods: IInviteUserMethods;

  constructor() {
    this.methods = {
      inviteUser: this.inviteUser.bind(this),
    };
  }

  async inviteUser(args: InviteUserProps) {
    let gql = Graphql.withBaseUrl(apiConfig.gql.url);
    // const token = getToken();
    const token = loginSrv()?.getToken();
    if (token) {
      gql = gql.withHeaders({
        authentication: token,
      });
    }
    const client = gql.getClient();

    console.log('data in query master admin invite', args);
    const storageService = StorageModule.getInstance();
    const _localData = storageService.get('userProfile', 'local');
    const _sessionData = storageService.get('userProfile', 'session');
    const userData = _sessionData ?? _localData;
    try {
      if (client) {
        const res = await client
          .mutation(
            INVITE_ORG,

            {
              input: {
                name: args?.orgName,
                owner: {
                  email: args?.email,
                },
                email: args?.email,
                role: 'BUSSINESS_ORG',
              },
            }
          )
          .toPromise();

        if (res?.data) {
          console.log(`table data`, res);
          return {
            ...res?.data,
          };
        }
      }
    } catch (err: any) {
      throw err;
    }
  }
}
